import { render, staticRenderFns } from "./pressure-alarm-list.vue?vue&type=template&id=4ffe6494&scoped=true"
import script from "./pressure-alarm-list.vue?vue&type=script&lang=js"
export * from "./pressure-alarm-list.vue?vue&type=script&lang=js"
import style0 from "./pressure-alarm-list.vue?vue&type=style&index=0&id=4ffe6494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe6494",
  null
  
)

export default component.exports